<template>
	<div style="height: 100%" ag-grid>
		<div ref="agGridParent" class="ag-grid-parent d-flex flex-column position-relative" :class="{ 'nk-full-screen': fullScreenStatus, [`grid_${gridId}`]: true, }" @mouseover="showSettingButton(true)" @mouseleave="showSettingButton(false)" style="height:100%">
			<div v-if="buttons.length" ref="grid_buttons" tabindex="0" class=" text-right">
				<nk-button v-for="button in buttons" :key="button.id" :class="button.class" @click="button.handler" @submit="button.handler" :options="button.options" class="m-1" />
			</div>
			<ag-grid-vue ref="agGrid" class="ag-theme-alpine" style="height: 100%" :key="updateGrid" :columnDefs="columnDefsForAg" :rowData="rowData" :defaultColDef="defaultColDef" :sideBar="sideBar" :rowSelection="rowSelection" :suppressDragLeaveHidesColumns="true" :pagination="pagination" :rowGroupPanelShow="rowGroupPanelShow" :autoGroupColumnDef="autoGroupColumnDef" :groupTotalRow="groupTotalRow" :masterDetail="masterDetail" :detailCellRendererParams="detailCellRendererParams"
				@selection-changed="onSelectionChanged" :headerHeight="30" :floatingFiltersHeight="40" :paginationPageSize="paginationPageSize" :cacheBlockSize="rowModelType === 'serverSide' ? cacheBlockSize : null" :rowModelType="rowModelType" :rowHeight="rowHeight" :cellSelection="true" @grid-ready="onGridReady" :localeText="localText" :enableRtl="true" :animateRows="true" :paginationAutoPageSize="paginationAutoPageSize" :tooltipShowDelay="250" :tooltipHideDelay="2000"
				:enableBrowserTooltips="enableBrowserTooltips" :defaultExcelExportParams="defaultExcelExportParams" :suppressColumnVirtualisation="suppressColumnVirtualization" :rowClassRules="rowClassRules" :treeData="treeData" :groupDefaultExpanded="groupDefaultExpanded" :getDataPath="getDataPath" :getContextMenuItems="getContextMenuItems" :getMainMenuItems="getMainMenuItems" @rowGroupOpened="rowGroupOpened" @firstDataRendered="firstDataRendered" @rowClicked="rowClickEventHandler"
				@cellSelectionChanged="onRangeSelectionChanged" @cellDoubleClicked="cellDoubleClicked" @cellClicked="cellClicked" @cellKeyDown="cellKeyPress" @sortChanged="onSortChanged" @filterChanged="onFilterChanged" @columnVisible="onColumnDefsChanged" @columnResized="onColumnDefsChanged" @columnMoved="onColumnDefsChanged" @cell-value-changed="onCellValueChanged" @paginationChanged="onPaginationChanged" :getRowClass="getRowClass" :suppressRowHoverHighlight="suppressRowHoverHighlight"
				:columnHoverHighlight="columnHoverHighlight" :stopEditingWhenCellsLoseFocus="true" :groupDisplayType="groupDisplayType" :isRowMaster="isRowMaster" :getRowId="getRowId" @store-refreshed="onStoreRefreshed" :getServerSideGroupKey="getServerSideGroupKey" :isServerSideGroup="isServerSideGroup" :loading="options.loading" :paginationPageSizeSelector="paginationPageSizeSelector" :excelStyles="excelStyles" :selectionColumnDef="selectionColumnDef">
			</ag-grid-vue>
			<div v-show="cellSelectionAggReport" class=" p-1">
				<label> {{ $t('ag-grid-local.selectionCount') }}:
				</label>
				<span ref="lbRangeCount" class="pl-3"></span>
				<label>
					{{ $t('ag-grid-local.selectionCellCount') }}:
				</label>
				<span ref="lbCellCount" class="pl-3"></span>
				<label>
					{{ $t('ag-grid-local.summation') }}:
				</label>
				<span ref="lbEagerSum" class="pl-3"></span>
				<label>
					{{ $t('ag-grid-local.average') }}:
				</label>
				<span ref="lbAvg" class="pl-3"></span>
				<label>
					{{ $t('ag-grid-local.maximize') }}:
				</label>
				<span ref="lbMax" class="pl-3"></span>
				<label>
					{{ $t('ag-grid-local.minimize') }}:
				</label>
				<span ref="lbMin" class="pl-3"></span>
			</div>
			<grid-settings class="setting-button d-none " style="position: absolute;right:-1px" :style="{ 'top': buttons.length ? '35px' : '10px' }" :options="settingButtonOptions" ref="gridSettingButton"></grid-settings>
		</div>
		<div v-if="fullScreenStatus" class="grid-dim"></div>
	</div>
</template>

<script>
	import { AgGridVue } from "ag-grid-vue3"  // the AG Grid Vue Component
	import { LicenseManager } from 'ag-grid-enterprise'

	LicenseManager.setLicenseKey("DownloadDevTools_COM_NDEwMjM0NTgwMDAwMA==59158b5225400879a12a96634544f5b6")
	import jalaliMoment from 'jalali-moment'
	import "ag-grid-community/styles/ag-grid.css" // Core grid CSS, always needed
	import "ag-grid-community/styles/ag-theme-alpine.css" // Optional theme CSS
	// import "ag-grid-community/styles/ag-theme-material.css"; // Optional theme CSS
	import fsJson from '~/assets/resources/fa.json'
	import DateFilterComponent from './filters/date/dateFilterComp.js'
	import DateFloatingFilterComponent from './filters/date/dateFloatingFilterComp.js'
	import customStringFilterComp from './filters/customString/customStringFilterComp'
	import customStringFloatingFilterComp from './filters/customString/customStringFloatingFilterComp'
	import customPriceFilterComp from './filters/customPrice/customPriceFilterComp'
	import customPriceFloatingFilterComp from './filters/customPrice/customPriceFloatingFilterComp'
	import totalAndSubTotal from './totalAndSubTotal'
	import { helpers } from "@nikan/text-visualizer"
	import _ from "lodash"
	import { i18nInstance } from "@/plugins/localization"
	import $sc from "@/plugins/shortcut.collection"
	import GridSettings from './agGrid-settings.vue'
	import Nk_anime from '@/plugins/anime'
	import { mapActions, mapGetters } from 'vuex'
	import $ from 'jquery'
	import emptyId from '@/statics/empty-id'
	import nikanDate from '@/components/general/nikan-date.vue'
	import { isEmpty } from '@/statics/validators'
	import { post } from '~/plugins/nikan-api'
	import cloneDeep from 'lodash/cloneDeep'
	import { generateUUID } from '@/plugins/helper'
	import { bdAdd } from '@/plugins/big-decimal-helper'
	import { buildColumnLookup, buildDynamicFilterPayload, buildDynamicSortPayload } from './filters/dynamicFilterAdapter'

	const priceReg = /^-?\d+(?:[.,]\d+)*$/
	const constConvertedFiledInEmit = [
		{ field: 'code', emitConverter: (data) => data.toString() }
	]
	const cellEditorsDic = {
		date: nikanDate,
		input: 'agTextCellEditor',
		textarea: 'agLargeTextCellEditor',
		dropdown: 'agRichSelectCellEditor',
	}
	const regex = {
		regChecker: function (data, key) {
			return this[key].test(data)
		},
		price: /^-?\d+(?:[.,]\d+)*$/,
		email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
		mobile: /^(\+98|0)?9\d{9}$/,
		number: /^\d+$/
	}
	const generalValidationFunctions = {
		required: (data) => !isEmpty(data),
		email: (data) => regex.regChecker(data, 'email'),
		mobile: (data) => regex.regChecker(data, 'mobile'),
		number: (data) => regex.regChecker(data, 'number'),
		max: (data, meta) => {
			return data.toString().length <= meta?.length
		},
		min: (data, meta) => data.toString().length >= meta?.length,
	}
	let GRID_UUID = 100
	let GRID_FULL_SCREEN = false
	export default {
		name: "ag-grid",
		components: {
			AgGridVue,
			DateFilterComponent,
			DateFloatingFilterComponent,
			customStringFloatingFilterComp,
			customStringFilterComp,
			customPriceFilterComp,
			customPriceFloatingFilterComp,
			totalAndSubTotal,
			GridSettings
		},
		props: {
			options: {
				type: Object
			},
			data: {
				type: Array,
			},
			modelValue: {
				type: Object
			},
			focusAndSelect: {
				type: Object
			}
		},
		emits: ['rendered', 'preSelectedRowData', 'update:modelValue', 'rowGroupOpened', 'row_dbClicked', 'row_edited', 'destroyed', 'data_updated', 'storeRefreshed', 'grid-focus-out'],
		beforeCreate() {
			// console.time('AgRenderTime')
			this.gridId = GRID_UUID.toString()
			GRID_UUID += 1
		},
		beforeMount() {
			this.paginationPageJumpInput = null
			this.paginationPageJumpTotal = null
			this.manipulateProp()
			this.serverSideDataSource = {
				getRows: (params) => {


					const startRow = typeof params.request.startRow === 'number' ? params.request.startRow : 0
					const endRow = typeof params.request.endRow === 'number' ? params.request.endRow : startRow + (this.cacheBlockSize || 0)

					const pageSize = (endRow - startRow) || this.cacheBlockSize || this.paginationPageSize

					const pageOneBased = Math.floor(startRow / pageSize) + 1

					let data = {
						filter: {
							combineWithAnd: true
						},
						...cloneDeep(this.serverInfo.payload),
						// ...this.columnDefs.reduce((a, c) => {
						// 	a[c.field] = null
						// 	return a
						// }, {}),
						page: pageOneBased,
						pageSize: pageSize,

					}
					const { filters, consumedColIds } = buildDynamicFilterPayload(this.columnLookup, params.request.filterModel)
					data.filters = filters

					Object.keys(params.request.filterModel).forEach(x => {
						if (consumedColIds.includes(x)) return

						const value = params.request.filterModel[x]?.filter ? params.request.filterModel[x].filter : params.request.filterModel[x]
						const colDef = this.columnLookup.get(x)
						if (colDef && colDef.filterModel === 'metaData') {
							if (!data.filter.SchemaValues)
								data.filter.SchemaValues = []
							data.filter.SchemaValues.push({
								systemField: x,
								value: value
							})
						} else
							data.filter[x] = value
					})

					data.sorts = buildDynamicSortPayload(this.columnLookup, params.request.sortModel)
					let endpoint = this.serverInfo?.api?.url
					let fetchedData
					if (this.serverInfo.api.manipulateRequest) {
						const { payload, url, fakeRes } = this.serverInfo.api.manipulateRequest(params, data) || {}
						if (url) endpoint = url
						data = { ...data, ...payload }
						fetchedData = fakeRes
					}
					const firstResponse = (res) => {
						if (res?.data?.items) {
							res.data.items = res.data.items.map(x => {
								return { ...x, groupKeys: params.request.groupKeys }
							})

							this.$emit('grid-server-result', { response: res.data.items, request: data })
						}
						let result = typeof this.serverInfo.api.manipulateResponse === 'function' ? this.serverInfo.api.manipulateResponse(res, params, this.serverInfo.payload) : res
						this.gridApi.deselectAll()

						const aggregate = result?.aggregate ?? res?.data?.aggregate
						this.serverSideAggregate = aggregate

						params.success({
							...result,
						})
						if (this.serverInfo.pageNumber) {
							this.gridApi.paginationGoToPage(this.serverInfo.pageNumber)
							this.serverInfo.pageNumber = null
						}
						if (this.groupIncludeTotalFooter && aggregate) {
							let pinnedBottomData = this.generatePinnedBottomData(aggregate)
							this.gridApi.setGridOption('pinnedBottomRowData', pinnedBottomData)
						}
					}
					const secondResponse = () => {
						if (typeof this.serverInfo.finally === 'function') this.serverInfo.finally()
						this.autoSizeAllColumns()
						this.setupPaginationPageJump()
						if (this.rowSelection.mode === 'multiRow')
							this.options?.focusAndSelect?.allowFocus && this.setSelectedRows()
					}
					if (fetchedData) {
						this.isServerSideLoading = false
						firstResponse(fetchedData)
						secondResponse()
					} else
						post(endpoint, data, null, { preventConcurrent: false }).then((res) => {
							firstResponse(res)

						}).then(res => {
							secondResponse()
							this.focusOnGrid()
						}).catch((err) => {
							params.fail()
						}).finally(() => {
							this.isServerSideLoading = false
						})


				},

			}
			this.defaultColDef.filterParams = {
				debounceMs: this.rowModelType === 'serverSide' ? 1500 : 10,
				maxNumConditions: this.rowModelType === 'serverSide' ? 1 : 2,
			}

		},
		mounted() {
			// console.timeEnd('AgRenderTime')

			this.resizeObserver = new ResizeObserver((page) => {
				// console.log('page',page[0].contentBoxSize[0].inlineSize)
				// console.log('this.lastObserverParentGridWidth',this.lastObserverParentGridWidth)
				if (this.lastObserverParentGridWidth !== page[0].contentBoxSize[0].inlineSize) {
					this.lastObserverParentGridWidth = page[0].contentBoxSize[0].inlineSize
					this.autoSizeAllColumns()
				}
			})
			this.resizeObserver.observe(this.$refs.agGridParent)
			// console.log('el',this.$el)
			// this.gridOptionIconEl = $('#agGridSettingIcon')[0]
			// console.log('optionButton',this.gridOptionIconEl)
			// this.gridOptionIconEl.addEventListener('click',this.clickOnGridOptionIcon)
			// this.$nextTick(()=>{
			//   this.$emit('rendered')
			// })

			// add background color for tree
			if (this.treeData && this.treeLevelRowColors !== false)
				for (let i = 1; i <= 5; i++) {
					this.rowClassRules[`tree-level-${i}`] = (params) => params.data?.hierarchy && params.data?.hierarchy?.length === i
				}
		},
		beforeUnmount() {
			this.resizeObserver.disconnect()
			if (this.fullScreenStatus) {
				let foundFullScreens = $('#app').find('.nk-full-screen')
				foundFullScreens.length === 1 && this.menu_show(true)
			}
			this.destroyed = true
			this.$emit('destroyed')
			// this.gridOptionIconEl.removeEventListener('click',this.clickOnGridOptionIcon)
		},
		created() {
			this.rowClassRules = {
				'row-deleted': (params) => params.data?.rowState === 'deleted',
				'validation-warning': (params) => {
					return params.data?.hiddenValidationColumn
				},
			}

		},
		data() {
			return {
				getRowId: (params) => params.data.id,
				isServerSideGroup: null,
				getServerSideGroupKey: null,
				pageNumber: 1,
				watchData: true,
				destroyed: false,
				activeValidation: true,
				timeoutColumnDefs: null,
				timeoutColumnResized: null,
				rawId: null,
				activeStateIsExist: false,
				currentColumnDefs: [],
				originalColDefs: null,
				localModelValue: null,
				rowHeight: 30,
				getDataPath: () => { },
				isGroupOpenByDefault: null,
				groupDefaultExpanded: 0,
				treeData: false,
				treeLevelRowColors: true,
				rowClassRules: null,
				excelExportParams: {},
				csvExportParams: {},
				lastObserverParentGridWidth: 0,
				enableBrowserTooltips: false,
				resizeObserver: null,
				settingButtonOptions: {},
				fullScreenStatus: false,
				gridId: -1,
				gridOptionIconEl: null,
				updateGrid: false,
				buttons: [],
				resizeTimeout: null,
				nestedFieldName: null,
				doubleClickedToSelect: false,
				fitToWidth: false,
				enterToSelect: false,
				columnLookup: null,
				rowSelection: {
					mode: 'multiRow',
					checkboxes: false,
					headerCheckbox: false,
					enableClickSelection: true,
					rowMultiSelectWithClick: false,
					enableSelectionWithoutKeys: false
				},
				keepSelectionOrder: false,
				cellSelectionAggReport: true,
				pagination: true,
				rowModelType: 'clientSide',
				paginationPageSize: 100,
				cacheBlockSize: 100,
				paginationPageSizeSelector: false,
				serverSideDataSource: null,
				serverSideAggregate: null,
				serverInfo: {
					pageNumber: null
				},
				timeoutForCallServer: null,
				paginationAutoPageSize: true,
				groupIncludeTotalFooter: false,
				masterDetail: false,
				contextMenuItems: [],
				isServerSideLoading: false,
				selectionColumnDef: {
					pinned: 'right',
					width: 50,
					lockPinned: true
				},
				sideBar: {
					toolPanels: [
						{
							id: 'columns',
							labelDefault: 'Columns',
							labelKey: 'columns',
							iconKey: 'columns',
							toolPanel: 'agColumnsToolPanel',
							minWidth: 225,
							maxWidth: 225,
							width: 225,
							toolPanelParams: {
								suppressRowGroups: true,
								suppressValues: true,
								suppressPivots: true,
								suppressPivotMode: true,
								suppressColumnFilter: false,
								suppressColumnSelectAll: false,
								suppressColumnExpandAll: false,
							},
						},
						{
							id: 'filters',
							labelDefault: 'Filters',
							labelKey: 'filters',
							iconKey: 'filter',
							toolPanel: 'agFiltersToolPanel',
							minWidth: 180,
							maxWidth: 400,
							width: 250
						}
					],
					position: 'right',
					defaultToolPanel: ''
				},
				detailCellRendererParams: {
					detailGridOptions: {
						rowSelection: {
							mode: 'multiRow',
							checkboxes: false,
							headerCheckbox: false,
							enableClickSelection: true,
							rowMultiSelectWithClick: true,
							enableSelectionWithoutKeys: true
						},
						cellSelection: true,
						pagination: false,
						paginationAutoPageSize: true,
						localeText: fsJson['ag-grid-local'],
						enableRtl: true,
						columnDefs: [],
						defaultColDef: {
							flex: 1,
							sortable: true,
							filter: true,
							minWidth: 150,
							resizable: true,
							floatingFilter: false,
						},
					},
					getDetailRowData: (params) => {
						params.successCallback(params.data[this.nestedFieldName])
					},
				},
				autoGroupColumnDef: {
					// minWidth: 70,
					// cellRendererParams: {
					// 	innerRenderer: 'totalAndSubTotal',
					// 	// footerValueGetter: params =>  {
					// 	//   const isRootLevel = params.node.level === -1;
					// 	//   if (isRootLevel) {
					// 	//     return 'مجموع کل';
					// 	//   }
					// 	//   return `مجموع (${params.value})`;
					// 	// },
					// 	rowData: null,
					// }
				},
				rowGroupPanelShow: 'rowGroupPanelShow',
				// rowGroupPanelShow : 'onlyWhenGrouping',
				localText: fsJson['ag-grid-local'],
				// onGridReady,
				columnDefsForAg: [],
				columnDefs: [],
				rowData: [],
				defaultColDef: {
					enableCellChangeFlash: true,
					sortable: true,
					filter: true,
					// flex: 1,
					minWidth: 70,
					resizable: true,
					floatingFilter: true,
					filterParams: {
						defaultToNothingSelected: true,
						buttons: ["reset"],
					}
				},
				defaultExcelExportParams: {
					autoConvertFormulas: true, // instead of dataType='Formula'
					processCellCallback: params => {
						params.data = params.node?.data
						const valueGetter = params.column.colDef.valueFormatter
						return !!valueGetter ? valueGetter(params) : params.value
					}
				},
				groupDisplayType: {},
				isRowMaster: () => true,
				suppressColumnVirtualization: true,
				gridApi: null,
				columnApi: null,
				expandedNodes: new Map(),
				onFirstDataRendered: null,
				onRowClicked: null,
				watchForSelectedChanges: false,
				excelStyles: [
					{
						id: 'stringCell',
						dataType: 'String',
					}
				],
			}
		},
		watch: {
			modelValue: {
				deep: true,
				immediate: true,
				handler(val) {
					this.localModelValue = _.clone(val)
					// console.log('watch modelValue', val)
					if (this.watchForSelectedChanges)
						this.setSelectedRows()
				}
			},
			data: {
				deep: true,
				handler(val) {
					if (this.watchData) {
						this.updateGrid = !this.updateGrid
						this.manipulateProp()
						this.gridApi && this.gridApi.updateGridOptions({ rowData: this.rowData })
					}
				}
			},
			'options.focusAndSelect': {
				deep: true,
				// immediate:true,
				handler(value) {
					// console.log('focusAndSelect', value,this.modelValue)
					value?.allowFocus && this.setSelectedRows()
				}
			},
			'options.fitToWidth': {
				handler(val) {
					this.autoSizeAllColumns()
				}
			},
			'options.buttons': {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					this.computeButtons(val)
				},
			},
			'options.groupDefaultExpanded': {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					this.groupDefaultExpanded = val
				},
			},

			// options:{
			//   deep:true,
			//   handler(){
			//     this.manipulateProp()
			//   }
			// },
		},
		computed: {
			...mapGetters({
				getActiveState: 'appStates/getActiveByKey',
			}),
			id() { return 'agGrid_' + this.rawId },
			identifier() { return this.options.rowIdentifier || 'id' },
			loadedNodes() {
				const nodes = []
				this.gridApi.forEachNode((node) => {
					nodes.push(node)
				})
				return nodes
			}
		},
		methods: {
			...mapActions({
				menu_show: 'hide_show',
				syncStates: 'appStates/sync',
				modifyStates: 'appStates/modify',
				refreshStates: 'appStates/refresh',
			}),
			onStoreRefreshed(event) {
				this.$emit('storeRefreshed', event)
			},
			/**
			 * @param rowsData:{add:any[],remove:any[],update:[]}
			 */
			setDataOnRow(rowsData) {
				if (rowsData.update) {
					let itemsToUpdate = []
					this.gridApi.forEachNodeAfterFilterAndSort((rowNode, index) => {
						const rowNodeData = rowNode.data
						const foundRow = rowsData.update.find(x => x[this.identifier] === rowNodeData[this.identifier])
						if (foundRow && foundRow[this.identifier] === rowNodeData[this.identifier]) {
							itemsToUpdate.push({ ...rowNodeData, ...foundRow })
						}
					})
					this.gridApi.applyTransaction({ update: itemsToUpdate })
				} else {
					this.gridApi.applyTransaction(rowsData)
				}
			},
			redrawRows() {
				this.gridApi.redrawRows()
			},
			setSettingButtonOptions() {
				this.settingButtonOptions = {
					buttons: [
						{
							id: this.idGenerator(5),
							displayOrder: 8,
							handler: () => this.fullScreen(),
							class: "no-outline",
							type: 'nk-btn',
							visible: true,
							options: {
								isPrimary: false,
								tooltipEnabled: true,
								hideTitle: true,
								icon: () => this.fullScreenStatus ? 'fa-solid fa-compress' : 'fa-solid fa-expand',
								title: () => this.fullScreenStatus ? i18nInstance.global.t('table.buttons.minimize') : i18nInstance.global.t('table.buttons.maximize'),
								shortcut: $sc.find('full-screen', 'table'),
								element: () => this.$el,
							}
						},
						{
							id: this.idGenerator(5),
							displayOrder: 9,
							handler: () => this.resetFactory(),
							class: "no-outline",
							type: 'nk-btn',
							visible: this.activeStateIsExist,
							options: {
								isPrimary: false,
								tooltipEnabled: true,
								hideTitle: true,
								icon: 'fa-solid fa-rotate-left',
								title: this.$t('table.buttons.reset-factory'),
								// shortcut: $sc.find('full-screen', 'table'),
								// element: () => this.$el,
							}
						}
					],

				}
			},
			firstDataRendered(params) {
				this.setupPaginationPageJump()
				this.autoSizeAllColumns()
				this.defer(() => {
					if (this.groupIncludeTotalFooter && this.rowData.length && this.rowModelType !== 'serverSide') {
						let pinnedBottomData = this.generatePinnedBottomData()
						this.gridApi.setGridOption('pinnedBottomRowData', pinnedBottomData)
					}
					this.options.focusAndSelect?.allowFocus && this.setSelectedRows()
				}, 1
				)
				if (typeof this.onFirstDataRendered === 'function')
					this.onFirstDataRendered(params)
			},
			rowClickEventHandler(event) {
				if (typeof this.onRowClicked === 'function') {
					this.onRowClicked(event)
				}
			},
			async resetFactory() {
				if (!this.rawId) return
				let state = this.getActiveState(this.id)
				if (state) {
					state.rowState = 'deleted'
					this.modifyStates([state])
					await this.syncStates()
					this.manipulateProp()
					this.updateGrid = !this.updateGrid
					// this.gridApi.setRowData(this.rowData)
				}


			},
			saveGridState(immediate = false) {
				const syncFunction = () => {
					this.syncStates()
					this.activeStateIsExist = true
					this.setSettingButtonOptions()
				}
				let state = this.getActiveState(this.id)
				if (!state) {
					state = {
						id: emptyId,
						key: this.id,
						name: this.id.replace('agGrid_', ''),
						isActive: true,
						rowState: 'new',
					}
				} else {
					state.rowState = 'changed'
				}

				state.value = this.currentColumnDefs
				// console.log('state',state)

				this.modifyStates([state])
				if (state.rowState === 'new') syncFunction()
				else {
					clearTimeout(this.timeoutColumnDefs)
					this.timeoutColumnDefs = setTimeout(() => {
						try {
							syncFunction()
						} catch (e) {
							console.log(e)
						}
					}, immediate ? 0 : 5000)
				}

			},
			onColumnDefsChanged(val) {
				if (!this.rawId) return
				const allowedSource = ["toolPanelUi", "uiColumnResized", "uiColumnMoved", "columnMenu"]
				if (!allowedSource.some(x => val.source === x)) return

				const operator = {
					columnMoved: (foundAffectedColDef) => {
						if (foundAffectedColDef) {
							const currInd = this.currentColumnDefs.findIndex(x => x.field === foundAffectedColDef.field && x.headerName === foundAffectedColDef.headerName)
							this.currentColumnDefs.splice(currInd, 1)
							this.currentColumnDefs.splice(val.toIndex, 0, foundAffectedColDef)
						}
					},
					columnResized: (foundAffectedColDef) => {
						if (foundAffectedColDef) {
							foundAffectedColDef.width = val?.column?.actualWidth
							foundAffectedColDef.suppressSizeToFit = true
						}
					},
					columnVisible: (foundAffectedColDef) => {
						if (foundAffectedColDef)
							foundAffectedColDef.hide = !val?.column?.visible

					},
				}

				const findAndSaveAffectedColumns = () => {
					const columns = val?.columns || [val?.column]

					for (let column of columns) {
						let col

						for (let currentCol of this.currentColumnDefs) {
							if (currentCol.field === column.colDef?.field && currentCol.headerName === column.colDef?.headerName) {
								col = currentCol
								break
							}

							if (column.originalParent && currentCol.children && currentCol.headerName === column.originalParent?.colGroupDef?.headerName) {
								col = currentCol.children.find(x => x.field === column.colDef?.field && x.headerName === column.colDef?.headerName)

								if (col)
									break
							}
						}

						if (col && operator[val.type]) {
							operator[val.type](col)
						}
					}

					this.saveGridState()
				}

				if (val.type === 'columnResized') {
					clearTimeout(this.timeoutColumnResized)
					this.timeoutColumnResized = setTimeout(() => {
						findAndSaveAffectedColumns()
					}, 500)
				} else findAndSaveAffectedColumns()


			},
			getMainMenuItems(params) {
				return [
					'columnChooser',
					'separator',
					'autoSizeThis',
					'autoSizeAll',
					'separator',
					{
						name: this.$t('ag-grid-local.saveColumnsState'),
						action: () => this.saveGridState(true)
					},
					{
						name: this.$t('ag-grid-local.resetColumnsState'),
						action: this.resetFactory
					}
				]
			},
			getContextMenuItems(params) {
				const printParams = {
					columnWidth: 100,
					fileName: 'گزارش',
					sheetName: 'نیکان',
					exportedRows: 'filteredAndSorted'
				}
				const csvPrintParams = _.merge({}, printParams, this.csvExportParams)
				const excelPrintParams = _.merge({}, printParams, this.excelExportParams)
				const elementCreator = (styleClass) => {
					return `<span class="${styleClass}" unselectable="on" role="presentation"></span>`
				}
				let temp = []
				if (!this.options?.hideContextMenuExport && !this.options?.hideExport) {
					temp = ['separator',
						{
							name: this.$t('ag-grid-local.export'),
							subMenu: [
								{
									name: this.$t('ag-grid-local.csvExport'),
									action: () => this.gridApi.exportDataAsCsv(csvPrintParams),
									icon: elementCreator('ag-icon ag-icon-csv'),
								},
								{
									name: this.$t('ag-grid-local.excelExport'),
									action: () => {

										this.gridApi.exportDataAsExcel({
											...excelPrintParams, shouldRowBeSkipped: (params) => {
												const node = params.node

												if (node.data['$__isAggregateRow']) return true

												return false
											}
										})
									},
									icon: elementCreator('ag-icon ag-icon-excel'),
								},
								{
									name: this.$t('ag-grid-local.exportExcelSelected'),
									action: () => {

										this.gridApi.exportDataAsExcel({
											...excelPrintParams, onlySelectedAllPages: true, onlySelected: true, shouldRowBeSkipped: (params) => {
												const node = params.node

												if (!node.isSelected()) return true

												if (!node.displayed) return true

												if (node.data['$__isAggregateRow']) return true

												return false
											}
										})
									},
									icon: elementCreator('ag-icon ag-icon-excel'),
								},
							],
						},

					]
				}
				if (this.rowSelection.mode === 'multiRow') temp = [...temp, 'separator', {
					name: this.$t('ag-grid-local.selected-row.name'),
					subMenu: [
						{
							name: this.$t('ag-grid-local.selected-row.all'),
							action: () => {
								this.gridApi.selectAll()
							},
						},
						{
							name: this.$t('ag-grid-local.selected-row.empty'),
							action: () => {
								this.gridApi.deselectAll()

							},
						},
						{
							name: this.$t('ag-grid-local.selected-row.reverse'),
							action: () => {
								const gotSelectedList = this.gridApi.getSelectedRows()
								this.gridApi.selectAll()
								this.gridApi.forEachNode((node, ind) => {
									if (gotSelectedList.some(x => x[this.options.rowIdentifier || 'id'] === node.data[this.options.rowIdentifier || 'id']))
										node.setSelected(false)
								})
							},
						},
					]

				}]
				const optionItems = this.options.getContextMenuItems ? this.options.getContextMenuItems(params) : []

				return [...(params.defaultItems ? params.defaultItems.filter((x, ind) => ind <= 4) : []), ...temp, 'separator', ...optionItems]
			},
			showSettingButton(status) {
				const anime = new Nk_anime(`.setting-button`, {
					translateX: 0,
					translateY: 0,
					easing: 'linear',
					duration: 250,
					begin: () => {
						if (this.$refs.gridSettingButton) {
							this.$refs.gridSettingButton.$el.classList.remove('d-none')
							this.$refs.gridSettingButton.$el.classList.add('d-block')
						}
					}
				})
				const before_anime = new Nk_anime(`.setting-button`, {
					translateX: 8,
					translateY: 0,
					easing: 'linear',
					duration: 250,
					complete: () => {
						if (this.$refs.gridSettingButton) {
							this.$refs.gridSettingButton.$el.classList.remove('d-block')
							this.$refs.gridSettingButton.$el.classList.add('d-none')
						}
					}
				})
				if (status) {
					anime.play()
				} else {
					before_anime.play()
				}
			},
			fullScreen() {
				this.fullScreenStatus = !this.fullScreenStatus
				if (this.gridId === 101) GRID_FULL_SCREEN = this.fullScreenStatus
				const anime = new Nk_anime(`.grid_${this.gridId}`, {
					translateX: 70,
					translateY: -80,
					easing: 'linear',
					duration: 500,
				})
				const before_anime = new Nk_anime(`.grid_${this.gridId}`, {
					translateX: 0,
					translateY: 0,
					easing: 'linear',
					duration: 500,
				})
				this.fullScreenStatus ? anime.play() : before_anime.play()
				if (this.fullScreenStatus) this.menu_show(false)
				else {
					!GRID_FULL_SCREEN && this.menu_show(true)
				}
				// this.autoSizeAllColumns()
			},
			selectedRowEmitter(key, data, event) {
				let _data = _.cloneDeep(data)
				let emmitConverters = this.columnDefs.filter(x => x.emitConverter)
				emmitConverters = [...constConvertedFiledInEmit, ...emmitConverters]
				if (Array.isArray(_data)) _data = _data.map(x => {
					constConvertedFiledInEmit.forEach(y => {
						if (x[y.field]) x[y.field] = y.emitConverter(x[y.field])
					})
					return x
				})
				else emmitConverters.forEach(y => {
					if (_data && _data[y.field]) _data[y.field] = y.emitConverter(_data[y.field])
				})
				this.$emit(key, _data, event)
				return _data
			},
			onCellValueChanged(event) {
				this.$emit('row_edited', event)
			},
			autoSizeAllColumns() {
				const displayWidth = this.$el.querySelector('.ag-grid-parent').clientWidth
				const totalColDefWidth = this.columnDefs.reduce((a, c) => {
					if (c.children) a = a + c.children.reduce((a2, c2) => a2 = a2 + (c2.width ? c2.width : 100), 0)
					a = a + (c.width ? c.width : 100)
					return a
				}, 0)
				// console.log('displayWidth',displayWidth)
				// console.log('totalColDefWidth',totalColDefWidth)
				this.suppressColumnVirtualization = false
				const agState = this.getActiveState('agGrid_' + this.rawId)
				const setColumnWidth = () => {
					this.defaultColDef.flex = 0
					if (this.gridApi) {
						let allColIds = this.gridApi.getAllDisplayedColumns()
							.filter(x => typeof x.colDef.suppressSizeToFit === 'undefined' || !x.colDef.suppressSizeToFit)
							.map(column => column.colId)
						// console.log('allColIds',allColIds)
						this.gridApi.autoSizeColumns(allColIds)
					}
				}
				if ((this.fitToWidth || totalColDefWidth <= displayWidth) && !agState?.value) {
					// this.gridColumnApi.autoSizeAllColumns();
					// console.log('this.gridApi',this.gridApi)
					this.defaultColDef.flex = 1
					if (this.gridApi) this.gridApi.sizeColumnsToFit()
				} else {
					setColumnWidth()

				}
				this.suppressColumnVirtualization = true
			},
			generatePinnedBottomData(aggregate) {
				if (aggregate) {
					return this.buildServerSidePinnedRow(aggregate)
				}
				const calculatePinnedBottomData = (target, rowData) => {
					target.id = generateUUID()
					target['$__isAggregateRow'] = true
					//**list of columns fo aggregation**
					let columnsWithAggregation = this.columnDefs.filter(x => x.aggFunc || x.children?.some(y => y.aggFunc)).reduce((acc, curr) => {
						if (curr.children) acc = [...acc, ...curr.children.map(y => ({ ...y, aggregateList: [] }))]
						else acc.push({ ...curr, aggregateList: [] })
						return acc
					}, [])
					const toFiniteNumber = (value) => {
						if (typeof value === 'number') return Number.isFinite(value) ? value : null
						if (typeof value === 'string') {
							const num = Number(value.replace(/[^0-9.-]+/g, ""))
							return Number.isFinite(num) ? num : null
						}
						return null
					}
					const safeFormat = (col, rowNode) => {
						if (typeof col.valueFormatter !== 'function') return null
						try {
							return col.valueFormatter({ ...rowNode, value: rowNode.data[col.field] })
						} catch (e) {
							return null
						}
					}
					const fillAggregateList = (rowNode) => columnsWithAggregation.forEach(col => {
						const rawValue = rowNode.data?.[col.field]
						const valueFormatterResult = safeFormat(col, rowNode)

						const amount = toFiniteNumber(valueFormatterResult) ?? toFiniteNumber(rawValue)

						if (amount !== null) col.aggregateList.push(amount)
					})

					const rows = []

					if (rowData)
						rowData.forEach(rowNode => {
							fillAggregateList({ data: rowNode })
							rows.push(rowNode)
						})
					else
						this.gridApi.forEachNodeAfterFilter((rowNode) => {
							fillAggregateList(rowNode)
							rows.push(rowNode.data)
						})

					Object.keys(target).forEach(x => {
						const foundField = columnsWithAggregation.find(y => y.field == x)
						if (foundField) {
							const calcResult = this.calculator(foundField.aggFunc, foundField.aggregateList, rows)
							const hasNumericResult = Number.isFinite(Number(calcResult?.aggAmount))
							if (hasNumericResult && (foundField.aggregateList.length || foundField.aggFunc === 'count'))
								target[x] = `${calcResult.aggAmount}`
							else
								target[x] = null
							// target[x] = calcResult && `${calcResult.aggFuncFaName}${calcResult.aggFuncFaName ? ': ' : ''}${calcResult.aggAmount}`
						}
					})
					return target
				}

				// generate a row-data with null values
				let pinnedRowData = {}

				this.gridApi.getAllGridColumns().forEach(item => {
					pinnedRowData[item.colId] = null
				})
				const selectedRows = this.gridApi.getSelectedRows()
				let result = []
				if (selectedRows.length >= 2)
					result = [calculatePinnedBottomData(cloneDeep(pinnedRowData), selectedRows), calculatePinnedBottomData(pinnedRowData)]
				else
					result = [calculatePinnedBottomData(pinnedRowData)]

				return result
			},
			buildServerSidePinnedRow(aggregate) {
				let pinnedRow = {}
				this.gridApi.getAllGridColumns().forEach(item => {
					pinnedRow[item.colId] = null
				})
				const aggregateByField = typeof aggregate === 'object' && !Array.isArray(aggregate) ? aggregate : null
				if (aggregateByField) {
					Object.keys(aggregateByField).forEach(field => {
						if (field in pinnedRow || this.columnDefs.some(c => c.field === field)) {
							pinnedRow[field] = aggregateByField[field]
						}
					})
				}
				pinnedRow.id = generateUUID()
				pinnedRow['$__isAggregateRow'] = true
				return [pinnedRow]
			},
			cellKeyPress(event) {
				if (this.rowSelection.enableClickSelection && ['ArrowUp', 'ArrowDown'].includes(event.event.code) && this.rowSelection.mode !== 'multiRow') {
					const foundRowNode = this.gridApi.getRowNode(event.node.id)
					if (foundRowNode) {
						const targetIndex = event.event.code === 'ArrowUp' ? foundRowNode.rowIndex - 1 : event.event.code === 'ArrowDown' && foundRowNode.rowIndex + 1

						if (targetIndex < 0) {
							this.$emit('grid-focus-out')
						} else {
							const rowAtIndex = this.gridApi.getDisplayedRowAtIndex(targetIndex)
							if (rowAtIndex) rowAtIndex.setSelected(true, true)
							this.selectedRowEmitter('preSelectedRowData', rowAtIndex ? rowAtIndex.data : null)
						}
					}
				}
				if (this.enterToSelect && !event.event.shiftKey && event.event.code === 'Enter' || event.event.code === 'NumpadEnter') {
					if (this.rowSelection.mode === 'singleRow') {
						this.selectedRowEmitter('update:modelValue', event.data)
						this.selectedRowEmitter('row_dbClicked', event.data)
					}
					var currentCell = this.gridApi.getFocusedCell()
					if (typeof currentCell.column.colDef.editable === 'function' ? !currentCell.column.colDef.editable(event) : !currentCell.column.colDef.editable) {
						return
					}
					var lastRowIndex = this.gridApi.getDisplayedRowCount() - 1

					this.gridApi.stopEditing(true)
					this.gridApi.clearFocusedCell()
					const allCols = this.gridApi.getAllDisplayedColumns()
					const currentColIndex = allCols.findIndex((x) => x.colId === currentCell.column.colId)
					let foundNextCol = allCols.filter((x, ind) => ind > currentColIndex).find((x) => typeof x.colDef.editable === 'function' ? x.colDef.editable(event) : x.colDef.editable)
					if (foundNextCol) {
						this.gridApi.ensureIndexVisible(currentCell.rowIndex)
						this.gridApi.setFocusedCell(currentCell.rowIndex, foundNextCol.colId)
						this.gridApi.startEditingCell({
							rowIndex: currentCell.rowIndex,
							colKey: foundNextCol.colId
						})
					} else if (currentCell.rowIndex !== lastRowIndex) {
						let firstEditableCellInNextRow = allCols.find((x) => typeof x.colDef.editable === 'function' ? x.colDef.editable(this.gridApi.getDisplayedRowAtIndex(currentCell.rowIndex + 1)) : x.colDef.editable)
						if (firstEditableCellInNextRow)
							this.gridApi.startEditingCell({
								rowIndex: currentCell.rowIndex + 1,
								colKey: firstEditableCellInNextRow.colId
							})
					} else {
						this.gridApi.startEditingCell({
							rowIndex: 0,
							colKey: allCols.find((x) => typeof x.colDef.editable === 'function' ? x.colDef.editable(this.gridApi.getDisplayedRowAtIndex(0)) : x.colDef.editable).colId
						})
					}
				}
				if (this.treeData && event.event.shiftKey && event.event.code === 'Backslash') {
					if (event.data?.parent?.id) {
						this.expandedNodes = this.expandedNodes.filter(x => !event.node.allLeafChildren.some(y => y.key === x.id))
						this.localModelValue = event.node.parent.data
						// this code made bug in selecting tree rows
						// this.setSelectedRows()
						this.gridApi.setRowNodeExpanded(event.node.parent, false)

					}
				}
				if (['ArrowUp', 'ArrowDown'].includes(event.event.code) && this.rowSelection.mode === 'multiRow') {
					const foundRowNode = this.gridApi.getRowNode(event.node.id)
					if (foundRowNode) {
						const targetIndex = event.event.code === 'ArrowUp' ? foundRowNode.rowIndex - 1 : event.event.code === 'ArrowDown' && foundRowNode.rowIndex + 1

						if (targetIndex < 0) {
							this.$emit('grid-focus-out')
						}
					}
				}
			},
			rowGroupOpened(event) {
				let { data, expanded, node } = event
				if (data) {
					if (!node) {
						node = this.gridApi.getRowNode(data[this.identifier])
					}

					if (expanded) {
						while (node) {
							if (node.key) {
								this.expandedNodes.set(node.data[this.identifier], node.data)
								// this.expandedNodes.push(node.data)
							}
							node = node.parent
						}
					} else {
						this.expandedNodes.delete(node.data[this.identifier])
						this.loadedNodes.forEach((x) => {
							let found
							if (this.rowModelType === 'serverSide')
								found = x.data.groupKeys.some(y => y === node.data[this.identifier])
							else if (x.data.hierarchy)
								found = x.data.hierarchy.some(y => y === node.data[this.identifier])
							if (found) {

								this.expandedNodes.delete(x.data[this.identifier])
							}
						})
						// this.expandedNodes = this.expandedNodes.filter(x => x.id !== node.data.id || !this.loadedNodes.some(y=>y.groupKeys.some(z=>z === node.data.id)))
					}

				}
				this.$emit('rowGroupOpened', { ...data, expanded })
			},
			getSortedSelectedRows() {
				const selectedRows = []
				this.gridApi.forEachNodeAfterFilterAndSort((node) => {
					if (node.isSelected()) {
						selectedRows.push(node.data)
					}
				})
				return selectedRows
			},
			onSelectionChanged(data) {
				if (this.rowSelection.mode === 'multiRow' && data.source !== 'setSelectedRowsEvent') {
					const selectedRows = this.keepSelectionOrder ? this.getSortedSelectedRows() : this.gridApi.getSelectedRows()

					this.selectedRowEmitter('update:modelValue', selectedRows)

					this.rowSelection.rowMultiSelectWithClick = selectedRows.length > 1
					this.rowSelection.enableSelectionWithoutKeys = selectedRows.length > 1

					this.onFilterChanged()
					if (this.columnDefs.every(x => !x.editable))
						this.defer(() => {
							this.rowSelection.enableClickSelection = !(Array.isArray(this.localModelValue) && this.localModelValue.length === 0)
						}, 0)
				}
			},
			onSortChanged(e) {
				e.api.refreshCells()
			},
			onFilterChanged(e) {
				if (this.groupIncludeTotalFooter && this.rowModelType !== 'serverSide') {
					let pinnedBottomData = this.generatePinnedBottomData()
					this.gridApi.setGridOption('pinnedBottomRowData', pinnedBottomData)
				}
			},
			cellDoubleClicked(event) {
				if (this.doubleClickedToSelect)
					this.selectedRowEmitter('update:modelValue', event.data, event)
				this.selectedRowEmitter('row_dbClicked', event.data, event)
			},
			cellClicked(event) {
				// if (this.rowSelection.mode === 'singleRow') {
				this.selectedRowEmitter('preSelectedRowData', event.data, event)
				// }
				if (this.rowSelection.enableClickSelection && typeof event.node.id === 'number')
					this.gridApi.getRowNode(event.node.id).setSelected(true, true)
			},
			/**
			 *
			 * @param aggFunc string : sum ,max ,min ,count, avg
			 * @param aggList list of numbers
			 * @param rowDatas list of rows
			 * @return {{aggAmount: number, aggFuncFaName: string}}
			 */
			calculator(aggFunc, aggList, rowDatas) {
				const cells = (aggList || []).filter(c => typeof c === 'number' && Number.isFinite(c))
				const sum = (numberCells) => numberCells.reduce((acc, curr) => bdAdd(acc, curr), 0)
				const max = (numberCells) => numberCells.length ? numberCells.reduce((acc, curr) => acc >= curr ? acc : curr, numberCells[0]) : 0
				const min = (numberCells) => numberCells.length ? numberCells.reduce((acc, curr) => acc <= curr ? acc : curr, numberCells[0]) : 0

				let result = { aggFuncFaName: '', aggAmount: 0 }
				if (typeof aggFunc === 'function') {
					try {
						result.aggAmount = aggFunc(cells, rowDatas)
					} catch (e) {
						result.aggAmount = 0
					}
				} else {
					result.aggFuncFaName = this.$t('ag-grid-local.' + aggFunc)
					switch (aggFunc) {
						case 'sum':
							result.aggAmount = sum(cells)
							break
						case 'max':
							result.aggAmount = max(cells)
							break
						case 'min':
							result.aggAmount = min(cells)
							break
						case 'count':
							result.aggAmount = (aggList || []).length
							break
						case 'avg':
							result.aggAmount = cells.length ? sum(cells) / cells.length : 0
							break
						default:
							result.aggAmount = 0
					}
				}
				return result
			},
			onRangeSelectionChanged(event) {
				if (this.cellSelectionAggReport) {
					var cellRanges = this.gridApi.getCellRanges()
					// console.log('cellRanges',cellRanges)
					// if no selection, clear all the results and do nothing more
					if (!cellRanges || cellRanges.length === 0) {
						this.$refs.lbRangeCount.innerHTML = '0'
						this.$refs.lbEagerSumum.innerHTML = '-'
						this.$refs.lbAvg.innerHTML = '-'
						this.$refs.lbMax.innerHTML = '-'
						this.$refs.lbMin.innerHTML = '-'
						this.$refs.lbCellCount.innerHTML = '-'
						return
					}
					// set range count to the number of ranges selected
					this.$refs.lbRangeCount.innerHTML = cellRanges.length + ''
					let numberCells = []
					const rowDatas = []
					let totalCells = 0
					var api = this.gridApi
					const extractNumberInCell = (value, column, rowNode) => {
						totalCells = totalCells + 1
						// console.log('value', value)
						// console.log('rowNode', rowNode)
						if (typeof value === 'number') {
							numberCells.push(value)
						} else if (priceReg.exec(value)) {
							numberCells.push(Number(value.replace(/[^0-9.-]+/g, "")))
						} else {
							// console.log('column',column)
							if (column.colDef.valueFormatter) {
								let tempCol = { ...column, value: value, data: rowNode.data }
								let valueFormatted = column.colDef.valueFormatter(tempCol)
								// console.log('valueFormatted',valueFormatted)
								if (priceReg.exec(valueFormatted))
									numberCells.push(Number(typeof valueFormatted === 'string' ? valueFormatted.replace(/[^0-9.-]+/g, "") : valueFormatted))
							}

						}
					}
					if (cellRanges) {
						cellRanges.forEach((range) => {
							// get starting and ending row, remember rowEnd could be before rowStart
							var startRow = Math.min(
								range.startRow.rowPinned ? this.rowData.length - 1 : range.startRow.rowIndex,
								range.endRow.rowPinned ? this.rowData.length - 1 : range.endRow.rowIndex
							)
							var endRow = Math.max(
								range.startRow.rowPinned ? this.rowData.length - 1 : range.startRow.rowIndex,
								range.endRow.rowPinned ? this.rowData.length - 1 : range.endRow.rowIndex)

							for (var rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
								range.columns.forEach((column) => {
									var rowNode = api.getDisplayedRowAtIndex(rowIndex)

									// console.log('rowNode',rowNode)
									if (rowNode) {
										var value = api.getCellValue({ colKey: column.colId, rowNode: rowNode })

										extractNumberInCell(value, column, rowNode)
										rowDatas.push(rowNode.data)
									}
								})
							}
						})
					}
					// console.log('numberCells', numberCells)
					let sum = this.calculator('sum', numberCells, rowDatas)
					let max = this.calculator('max', numberCells, rowDatas)
					let min = this.calculator('min', numberCells, rowDatas)
					this.$refs.lbEagerSum.innerHTML = parseFloat(Number(sum.aggAmount).toFixed(2)).toString().toPriceFormat() + ''
					this.$refs.lbAvg.innerHTML = parseFloat(Number(this.calculator('avg', numberCells, rowDatas).aggAmount).toFixed(2)).toString().toPriceFormat() + ''
					this.$refs.lbMax.innerHTML = max.aggAmount || max.aggAmount == 0 ? parseFloat(Number(max.aggAmount).toFixed(2) + '').toString().toPriceFormat() : '--'
					this.$refs.lbMin.innerHTML = min.aggAmount || min.aggAmount == 0 ? parseFloat(Number(min.aggAmount).toFixed(2) + '').toString().toPriceFormat() : '--'
					this.$refs.lbCellCount.innerHTML = totalCells ? totalCells : '--'
				}
			},
			getDefaultButtons() {
				return {
					addBtn: {
						id: this.idGenerator(5),
						displayOrder: 1,
						handler: this.row_addRowAtEnd,
						class: "no-outline",
						type: 'nk-btn',
						options: {
							visible: false,
							isPrimary: false,
							icon: 'plus',
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.add'),
							shortcut: $sc.find('insert-new-row', 'table'),
							element: () => this.$el,
							hideShortcut: true,
						}
					},
					duplicateBtn: {
						id: this.idGenerator(5),
						displayOrder: 2,
						handler: this.duplicateRows,
						class: "mr-2 no-outline",
						type: 'nk-btn',
						options: {
							visible: false,
							icon: 'copy',
							isDanger: false,
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.copy'),
							shortcut: $sc.find('copy', 'table'),
							element: () => this.$el,
							hideShortcut: true,
						}
					},
					upBtn: {
						id: this.idGenerator(5),
						displayOrder: 3,
						handler: this.up,
						class: "mr-2 no-outline",
						type: 'nk-btn',
						options: {
							visible: false,
							icon: 'arrow-up',
							isDanger: false,
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.up'),
							shortcut: $sc.find('move-up', 'table'),
							element: () => this.$el,
							hideShortcut: true,
						}
					},
					downBtn: {
						id: this.idGenerator(5),
						displayOrder: 4,
						handler: this.down,
						class: "mr-2 no-outline",
						type: 'nk-btn',
						options: {
							visible: false,
							icon: 'arrow-down',
							isDanger: false,
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.down'),
							shortcut: $sc.find('move-down', 'table'),
							element: () => this.$el,
							hideShortcut: true,
						}
					},
					transferBtn: {
						id: this.idGenerator(5),
						displayOrder: 5,
						handler: this.transfer,
						class: "mr-2 no-outline",
						type: 'input-button',
						options: {
							visible: false,
							icon: 'fal fa-arrows-v',
							isDanger: false,
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.transfer'),
						}
					},
					deleteBtn: {
						id: this.idGenerator(5),
						displayOrder: 6,
						handler: this.row_deleteRow,
						class: "mr-2 no-outline",
						element: () => this.$el,
						type: 'nk-btn',
						options: {
							visible: false,
							icon: 'trash',
							isOutlineDanger: true,
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.delete'),
							shortcut: $sc.find('delete-row', 'table'),
							element: () => this.$el,
							hideShortcut: true,
						}
					},
					saveBtn: {
						id: this.idGenerator(5),
						displayOrder: 7,
						handler: () => this.resolve('save'),
						class: "mr-2 no-outline",
						type: 'nk-btn',
						options: {
							visible: false,
							isPrimary: true,
							icon: 'save',
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.save'),
						}
					},
				}
			},
			computeButtons(buttons) {
				let buttonsObj = _.merge(this.getDefaultButtons(), buttons)
				let buttonsArray = Object.values(buttonsObj) || []

				buttonsArray.map((x => {
					x.id ? x.id : x.id = this.idGenerator(5)
					x.options.visible ? x.options.visible : true
					x.options.disabled ? x.options.disabled : false
					return x
				}))

				buttonsArray = buttonsArray.filter(x => x.options.visible !== false)
				this.buttons = buttonsArray.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1)
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: `ag-grid-${this.idGenerator(5)}`,
					keyCode: [38, 40, 13], // 38:arrow-up 40:arrow-down ,
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						// just for let agGrid arrow keys event work properly
						return true
					},
				})

				this.$keyHandler.Subscribe({
					name: `ag-grid-up-down-arrows-${this.idGenerator(5)}`,
					keyCode: [38, 40], // 38:arrow-up 40:arrow-down ,
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						const findEditableColumn = (startIndex, directionIsDown) => {
							const rowsCount = this.gridApi.getDisplayedRowCount()

							for (let i = startIndex; directionIsDown ? i < rowsCount : i >= 0; directionIsDown ? i++ : i--) {
								const rowNode = this.gridApi.getDisplayedRowAtIndex(i)
								const column = this.gridApi.getColumn(editingCell.column.colId)

								if (rowNode && column) {
									if (column.isCellEditable(rowNode)) {
										this.gridApi.startEditingCell({
											rowIndex: i,
											colKey: editingCell.column.colId,
										})
										break
									} else if (i === rowsCount - 1 && directionIsDown)
										findEditableColumn(0, directionIsDown)
									else if (i === 0 && !directionIsDown)
										findEditableColumn(rowsCount - 1, directionIsDown)
								}
							}
						}
						const editingCell = this.gridApi.getEditingCells()[0]
						const focusedCell = this.gridApi.getFocusedCell()

						const isCurrent = editingCell && (editingCell.rowIndex === focusedCell.rowIndex) && (editingCell.column.colId === focusedCell.column.colId)

						if (isCurrent) {
							const directionIsDown = e.key === 'ArrowDown'
							let targetRowIndex = directionIsDown ? editingCell.rowIndex + 1 : editingCell.rowIndex - 1
							if (targetRowIndex < 0) {
								targetRowIndex = this.gridApi.getDisplayedRowCount() - 1
							} else if (targetRowIndex === this.gridApi.getDisplayedRowCount()) {
								targetRowIndex = 0
							}

							findEditableColumn(targetRowIndex, directionIsDown)

						}
					},
				})
			},
			setSelectedRows() {
				//  Note: I Changed eventSource of deselectAll and setSelected to 'setSelectedRowsEvent' so I can exclude this type of event from emitting data

				if (!this.gridApi || this.gridApi.isDestroyed()) return
				const isMultipleSelection = this.rowSelection.mode === 'multiRow'
				const selectedIds = !this.localModelValue ? [] : isMultipleSelection ? new Set(this.localModelValue?.map(item => item[this.identifier]) || []) : new Set([this.localModelValue[this.identifier]])

				// Deselect all nodes first
				this.gridApi.deselectAll('setSelectedRowsEvent')

				const processNode = (nodeId, select, focus = false) => {
					const rowNode = this.gridApi.getRowNode(nodeId)
					if (rowNode) {
						rowNode.setSelected(select, false, 'setSelectedRowsEvent')
						if (focus) {
							this.defer(() => {
								this.gridApi.ensureIndexVisible(rowNode.rowIndex)
								this.gridApi.setFocusedCell(rowNode.rowIndex, this.treeData ? "ag-Grid-AutoColumn" : this.columnDefs[0]?.field)
							}, 200)
						}
					}
				}

				// Select nodes based on localModelValue
				selectedIds.forEach(id => processNode(id, true, !isMultipleSelection))

				// Expand nodes if tree data is enabled
				if (this.treeData) {
					// const expandedIds = new Set(this.expandedNodes?.map(node => node.id) || [])
					this.expandedNodes.forEach((val, key) => {
						const rowNode = this.gridApi.getRowNode(key)
						if (rowNode) {
							this.gridApi.setRowNodeExpanded(rowNode, true, true)
						}
					})
				}

				// Handle single selection mode
				if (!isMultipleSelection) {
					const selectedRows = this.gridApi.getSelectedRows()
					if (!selectedRows.length) {
						const firstNodeId = this.gridApi.getDisplayedRowAtIndex(0)?.data?.[this.identifier]
						if (firstNodeId) {
							processNode(firstNodeId, true, true)
							this.selectedRowEmitter('preSelectedRowData', this.gridApi.getRowNode(firstNodeId)?.data)
						}
					}
				}

			},
			deselectAll() {
				this.gridApi.clearCellSelection()
				this.gridApi.deselectAll()
			},
			rowColorChanger(rowValidationStateList, rowIndex) {
				let reducedList = rowValidationStateList.reduce((a, c) => {
					a.find(x => x === c.rowIndex) ? false : a.push(c.rowIndex)
					return a
				}, [])
				this.gridApi.forEachNode((rowNode) => {
					let rowStatus = reducedList.some(x => rowNode.rowIndex == x)
					if (rowStatus || rowIndex == rowNode.rowIndex || !this.columnDefs.activeValidation)
						rowNode.setDataValue('hiddenValidationColumn', null)

				})
				this.gridApi.forEachNode(function (rowNode) {
					let rowStatus = reducedList.some(x => rowNode.rowIndex == x)
					if (rowStatus)
						rowNode.setDataValue('hiddenValidationColumn', true)

				})

			},
			validateRowData(colDef, data) {
				let messages = ''
				const notificationArray = []
				colDef.generalValidation && colDef.generalValidation.forEach(x => {
					!generalValidationFunctions[x.operation](data.newValue, x.meta) && notificationArray.push({
						rowIndex: data.node.childIndex,
						headerName: colDef.headerName,
						message: x.message
					})
				})
				colDef.validationFunc && colDef.validationFunc.forEach(x => {
					const fucReturnMessage = x(data.newValue, data.data, this.rowData)
					fucReturnMessage && notificationArray.push({
						rowIndex: data.node.childIndex,
						headerName: colDef.headerName,
						message: fucReturnMessage
					})
				})
				if (notificationArray.length) {
					messages += this.$t('ag-grid-local.validationRow', { rowNumber: notificationArray[0].rowIndex + 1, headerName: notificationArray[0].headerName })
					notificationArray.forEach(x => {
						messages += x.message + '\n'
					})
				}
				return { messages, notificationArray }
			},
			validateAllData() {
				if (!this.columnDefs.activeValidation) {
					let totalNotificationArr = []
					let messages = []
					this.gridApi.forEachNode(node => {
						this.columnDefs.forEach(colDef => {
							let rowData = {
								newValue: node.data[colDef.field] ? node.data[colDef.field] : null,
								node: node,
								data: node.data
							}
							let validationResult = this.validateRowData(colDef, rowData)
							totalNotificationArr = totalNotificationArr.concat(validationResult.notificationArray)
							if (validationResult.messages)
								messages = messages.concat(validationResult.messages)
						})
					})
					this.rowColorChanger(totalNotificationArr)

					if (totalNotificationArr.length) {
						this.validationToast(messages.map(x => { return { error: x } }))

					}
					if (totalNotificationArr.length === 0) {
						this.selectedRowEmitter('data_updated', this.rowData)
						return true
					} else return false
				}
				this.selectedRowEmitter('data_updated', this.rowData)
				return true
			},
			getData() {
				return this.selectedRowEmitter('data_updated', this.rowData)
			},
			getFilteredTableData() {
				if (this.rowModelType === 'serverSide') {
					return this.getActivePageData()
				}
				const filteredData = []
				this.gridApi.forEachNodeAfterFilter((node) => {
					filteredData.push(node.data)
				})

				return filteredData
			},
			getActivePageData() {
				if (!this.gridApi || this.gridApi.isDestroyed?.()) return []
				const count = this.gridApi.getDisplayedRowCount()
				const data = []
				for (let i = 0; i < count; i++) {
					const node = this.gridApi.getDisplayedRowAtIndex(i)
					if (node && node.data && !node.data.$__isAggregateRow) {
						data.push(node.data)
					}
				}
				return data
			},
			setQuickFilterValue(text) {
				this.gridApi.setGridOption('quickFilterText', text)
			},
			onGridReady(params) {
				this.gridApi = params.api
				if (this.rowModelType === 'serverSide') this.gridApi.setGridOption('serverSideDatasource', this.serverSideDataSource)
				else {
					this.gridApi.updateGridOptions({ rowData: this.rowData })
					this.$nextTick(() => {
						this.$emit('rendered')
					})
				}
				this.setupPaginationPageJump()
			},
			onPaginationChanged() {
				this.syncPaginationPageJump()
			},
			goToPageFromInput() {
				if (!this.gridApi || this.gridApi.isDestroyed?.()) return
				const totalPages = this.gridApi.paginationGetTotalPages()
				if (!totalPages || !this.paginationPageJumpInput) return

				let page = parseInt(this.paginationPageJumpInput.value, 10)
				if (Number.isNaN(page)) {
					this.syncPaginationPageJump()
					return
				}

				page = Math.max(1, Math.min(page, totalPages))
				this.paginationPageJumpInput.value = page

				const currentPage = this.gridApi.paginationGetCurrentPage() + 1
				if (page !== currentPage) {
					this.gridApi.paginationGoToPage(page - 1)
				}
			},
			setupPaginationPageJump() {
				if (!this.pagination) return

				this.$nextTick(() => {
					const gridEl = this.$refs.agGrid?.$el
					if (!gridEl) return

					const pagingPanel = gridEl.querySelector('.ag-paging-panel')
					if (!pagingPanel) return

					let container = pagingPanel.querySelector('.nk-pagination-page-jump')
					const pageSummaryPanel = pagingPanel.querySelector('.ag-paging-page-summary-panel')

					if (pageSummaryPanel) {
						pageSummaryPanel.style.display = ''
						const pageDescription = pageSummaryPanel.querySelector('.ag-paging-description')
						if (pageDescription) pageDescription.style.display = 'none'
					}

					if (container) {
						if (pageSummaryPanel && !pageSummaryPanel.contains(container)) {
							const btNext = pageSummaryPanel.querySelectorAll('.ag-paging-button')[2]
							if (btNext) pageSummaryPanel.insertBefore(container, btNext)
							else pageSummaryPanel.appendChild(container)
						}
						this.paginationPageJumpInput = container.querySelector('.nk-pagination-page-jump-input')
						this.paginationPageJumpTotal = container.querySelector('.nk-pagination-page-jump-total')
						this.syncPaginationPageJump()
						return
					}

					container = document.createElement('span')
					container.className = 'nk-pagination-page-jump ag-paging-description'

					const label = document.createElement('span')
					label.className = 'nk-pagination-page-jump-label'
					label.textContent = `${this.localText.page}: `

					const input = document.createElement('input')
					input.type = 'number'
					input.min = '1'
					input.className = 'form-control form-control-sm nk-pagination-page-jump-input'
					input.setAttribute('aria-label', this.localText.page)

					const totalSpan = document.createElement('span')
					totalSpan.className = 'nk-pagination-page-jump-total'

					input.addEventListener('keydown', (e) => {
						if (e.key === 'Enter') {
							e.preventDefault()
							this.goToPageFromInput()
							input.blur()
						}
					})
					input.addEventListener('blur', () => this.goToPageFromInput())

					container.appendChild(label)
					container.appendChild(input)
					container.appendChild(totalSpan)

					if (pageSummaryPanel) {
						const btNext = pageSummaryPanel.querySelectorAll('.ag-paging-button')[2]
						if (btNext) pageSummaryPanel.insertBefore(container, btNext)
						else pageSummaryPanel.appendChild(container)
					} else {
						pagingPanel.appendChild(container)
					}

					this.paginationPageJumpInput = input
					this.paginationPageJumpTotal = totalSpan
					this.syncPaginationPageJump()
				})
			},
			syncPaginationPageJump() {
				if (!this.paginationPageJumpInput || !this.gridApi || this.gridApi.isDestroyed?.()) return
				if (document.activeElement === this.paginationPageJumpInput) return

				const totalPages = this.gridApi.paginationGetTotalPages() || 1
				const currentPage = this.gridApi.paginationGetCurrentPage() + 1
				this.paginationPageJumpInput.value = currentPage
				this.paginationPageJumpInput.max = totalPages
				if (this.paginationPageJumpTotal) {
					this.paginationPageJumpTotal.textContent = ` ${this.localText.of} ${totalPages}`
				}
			},
			getSelectedRows() {
				return this.gridApi.getSelectedRows()
			},
			exportGridData(type = 'excel', printParams) {
				if (type === 'excel') {
					return this.gridApi.exportDataAsExcel(printParams)
				} else if (type === 'csv') {
					return this.gridApi.exportDataAsCsv(printParams)
				}

			},
			focusOnGrid() {
				this.gridApi.setFocusedCell(0, this.columnDefs[0].field)
			},
			manipulateData(row, colDef) {
				if (colDef?.contentType === 'number' && typeof row[colDef.field] === 'string') {
					row[colDef.field] = Number(row[colDef.field])
				}
				if (colDef?.contentType === 'price') row[colDef.field] = parseFloat(row[colDef.field]) || 0
				else if (colDef?.contentType === 'negativePrice') row[colDef.field] = parseFloat(row[colDef.field]) || 0
			},
			manipulateProp() {
				// console.log('ag $props', this.$props)
				const { options, data, selected } = this.$props.options.cloneProps || typeof this.$props.options.cloneProps === 'undefined' ? cloneDeep(this.$props) : this.$props

				const {
					columnDefs = [],
					isRowMaster,
					groupDisplayType,
					defaultColDef,
					sideBar,
					rowSelection,
					pagination,
					rowGroupPanelShow,
					autoGroupColumnDef,
					groupTotalRow,
					groupIncludeTotalFooter,
					masterDetail,
					cellSelectionAggReport,
					doubleClickedToSelect,
					enterToSelect,
					fitToWidth,
					treeData,
					treeLevelRowColors,
					groupDefaultExpanded,
					rowHeight,
					isGroupOpenByDefault,
					getDataPath,
					serverSideDatasource,
					serverInfo,
					paginationPageSize,
					id,
					rowModelType,
					activeValidation,
					getRowClass,
					rowClassRules,
					suppressRowHoverHighlight,
					columnHoverHighlight,
					onFirstDataRendered,
					detailCellRendererParams,
					onRowClicked,
					getRowId,
					watchData,
					watchForSelectedChanges,
					isServerSideGroup,
					getServerSideGroupKey,
					cacheBlockSize,
					paginationAutoPageSize,
					paginationPageSizeSelector,
					keepSelectionOrder,
					excelExportParams,
					csvExportParams
				} = options

				let hasPriceColumn = false

				const manipulateColDef = (colDef, index) => {
					colDef.field === 'code' && !colDef.contentType && (colDef.contentType = 'number')
					switch (colDef.contentType) {
						case 'date':
							const convertDate = (date) => {
								if (date.value?.includes('0001-01-01')) return ''
								return date.value && jalaliMoment(date.value, 'YYYY-M-D ')
									.locale('fa')
									.format('YYYY/MM/DD')
							}
							colDef.filter = 'DateFilterComponent'
							colDef.floatingFilterComponent = 'DateFloatingFilterComponent'
							!colDef.cellRenderer && (colDef.cellRenderer = (date) => convertDate(date))
							!colDef.valueFormatter && (colDef.valueFormatter = (date) => convertDate(date))
							!colDef.comparator && (colDef.comparator = (dateA, dateB) => jalaliMoment(dateA, 'YYYY-M-D ').diff(jalaliMoment(dateB, 'YYYY-M-D '), 'day')
							)
							break

						case 'datetime':
							const convertDateTime = (date) => {
								if (date.value?.includes('0001-01-01')) return ''
								return date.value && jalaliMoment(date.value, 'YYYY-M-DTHH:mm')
									.locale('fa')
									.format('HH:mm YYYY/MM/DD')
							}
							colDef.filter = 'DateFilterComponent'
							colDef.floatingFilterComponent = 'DateFloatingFilterComponent'
							!colDef.cellRenderer && (colDef.cellRenderer = (date) => convertDateTime(date))
							!colDef.valueFormatter && (colDef.valueFormatter = (date) => convertDateTime(date))
							!colDef.comparator && (colDef.comparator = (dateA, dateB) => jalaliMoment(dateA, 'YYYY-M-DTHH:mm').diff(jalaliMoment(dateB, 'YYYY-M-DTHH:mm'), 'minute')
							)
							break
						case 'number':
							colDef.filter = 'agNumberColumnFilter'
							if (colDef.aggFunc && !colDef.valueFormatter) colDef.valueFormatter = (params) => params.value
							break
						case 'price':
							hasPriceColumn = true

							colDef.filter = 'agNumberColumnFilter'
							colDef.filter = 'customPriceFilterComp'
							colDef.floatingFilterComponent = 'customPriceFloatingFilterComp'
							!colDef.valueFormatter && (colDef.valueFormatter = data => {
								return colDef.ignoreNegative !== true ? parseFloat(data.value) : Math.abs(parseFloat(data.value))
							})
							colDef.keyCreator = colDef.valueFormatter
							!colDef.cellRenderer && (colDef.cellRenderer = data => {
								if (priceReg.exec(data.value)) {
									const formattedPrice = helpers.formatPrice(Math.abs(data.value))
									return data.value < 0 && colDef.ignoreNegative !== true ? `<span class="text-danger">(${formattedPrice})</span>` : formattedPrice
								}
								else return data.value
							})
							colDef.comparator = (valueA, valueB, nodeA, NodeB) => {
								valueA = Number(valueA)
								valueB = Number(valueB)
								if (valueA == valueB) return 0
								return (valueA > valueB) ? 1 : -1
							}
							!colDef.aggFunc && (colDef.aggFunc = 'sum')
							break
						case 'string':
							colDef.filter = 'agTextColumnFilter'
							break
						case 'enum':
							colDef.keyCreator = colDef.valueFormatter
							colDef.filterParams = {
								valueFormatter: colDef.valueFormatter,
								options: { inputOptions: { mode: colDef.filter === 'customPrice' ? 'price' : 'ninteger' } }
							}
							switch (colDef.filter) {
								case 'customString':
									colDef.filter = 'customStringFilterComp'
									colDef.floatingFilterComponent = 'customStringFloatingFilterComp'
									break
								case 'customPrice':
									colDef.filter = 'customPriceFilterComp'
									colDef.floatingFilterComponent = 'customPriceFloatingFilterComp'
									break
								case 'customNegativeNumber':
									colDef.filter = 'customPriceFilterComp'
									colDef.floatingFilterComponent = 'customPriceFloatingFilterComp'
									break
								default:
									if (!colDef.filter && !colDef.floatingFilterComponent) {
										colDef.filter = 'customStringFilterComp'
										colDef.floatingFilterComponent = 'customStringFloatingFilterComp'
									} else
										colDef.filter = colDef.filter ? colDef.filter : 'agSetColumnFilter'
									break
							}
							colDef.comparator = typeof colDef.comparator == 'function' ? colDef.comparator :
								(a, b, nodeA, nodeB, isDescending) => {
									let valueA
									let valueB
									if (typeof colDef.valueFormatter == 'function' && nodeA) {
										valueA = colDef.valueFormatter({ value: nodeA.data[colDef.field], data: nodeA.data })
										valueB = colDef.valueFormatter({ value: nodeB.data[colDef.field], data: nodeB.data })
									} else {
										valueA = a
										valueB = b
									}
									if (typeof valueA != 'number' && priceReg.exec(valueA)) valueA = Number(valueA.replace(/[^0-9.-]+/g, ""))
									if (typeof valueB != 'number' && priceReg.exec(valueB)) valueB = Number(valueB.replace(/[^0-9.-]+/g, ""))
									if (valueA == valueB) return 0
									return (valueA > valueB) ? 1 : -1
								}
							break
						default:
							if (!colDef.filter)
								colDef.filter = 'agTextColumnFilter'
							break
					}
					if (colDef.field === 'rowNumber') {
						!colDef.minWidth && (colDef.minWidth = 50)
						!colDef.width && (colDef.width = 85)
						!colDef.maxWidth && (colDef.maxWidth = 100)
						colDef.filter = false
						colDef.sortable = false
						colDef.lockPosition = 'right'
						colDef.suppressSizeToFit = true
						colDef.valueGetter = ` node.rowPinned == 'bottom'? node.data.rowNumber : node.rowIndex + 1 `
						colDef.aggFunc = 'count'
					}
					// this.enableBrowserTooltips = colDef.tooltipComponent
					if (colDef.cellEditor) {
						colDef.cellEditor = cellEditorsDic[colDef.cellEditor] ? cellEditorsDic[colDef.cellEditor] : colDef.cellEditor
						colDef.cellEditorParams = {
							...colDef.cellEditorParams,
							cellHeight: 35,
						}
						if (colDef.valueFormatter) colDef.cellEditorParams.formatValue = (data) => colDef.valueFormatter({ value: data })
						const valueSetter = colDef.valueSetter
						const defaultValueSetter = (params) => {
							let value = params.newValue

							if (['number', 'price'].includes(colDef.contentType)) {
								value = !isNaN(Number(params.newValue)) ? Number(params.newValue) : params.oldValue
							}
							if (!valueSetter)
								params.data[params.colDef.field] = value

							return valueSetter ? valueSetter(params, () => { setTimeout(() => this.autoSizeAllColumns(), 1) }) : true
						}

						if (this.activeValidation && (colDef.generalValidation || colDef.validationFunc)) {
							colDef.valueSetter = (params) => {
								let validationText = this.validateRowData(colDef, params)
								this.rowColorChanger(validationText.notificationArray, params.node.childIndex)
								if (validationText.notificationArray.length) {
									this.validationToast([{ error: validationText.messages }])
									// return false
								}
								return defaultValueSetter(params)
							}
						} else {
							colDef.valueSetter = (params) => defaultValueSetter(params)
						}
					}
					const isAggregateCell = (params) => !!params?.node?.data?.$__isAggregateRow
					const isAggregateNumeric = (colDef, params) => {
						const v = params?.value
						if (v === null || v === undefined || v === '') return false
						const num = Number(v)
						return Number.isFinite(num)
							&& (colDef.aggFunc || colDef.contentType === 'number' || colDef.contentType === 'price' || colDef.contentType === 'negativePrice')
					}
					if (typeof colDef.valueFormatter === 'function') {
						const originalValueFormatter = colDef.valueFormatter
						colDef.valueFormatter = (params) => {
							if (isAggregateCell(params)) {
								if (!isAggregateNumeric(colDef, params)) return ''
								return originalValueFormatter({ ...params, value: Number(params.value) })
							}
							return originalValueFormatter(params)
						}
					}
					if (typeof colDef.cellRenderer === 'function') {
						const originalCellRenderer = colDef.cellRenderer
						colDef.cellRenderer = (params) => {
							if (isAggregateCell(params)) {
								if (!isAggregateNumeric(colDef, params)) return ''
								return originalCellRenderer({ ...params, value: Number(params.value) })
							}
							try {
								return originalCellRenderer(params)
							} catch (e) {
								return ''
							}
						}
					}

					return colDef
				}
				// add column just for state flag of validation
				columnDefs.push({ field: 'hiddenValidationColumn', headerName: ' ', hide: true, editable: true, lockVisible: true })
				columnDefs.forEach((x, i) => {
					manipulateColDef(x, i)
					if (x.children) x.children.forEach((y, yIndex) => manipulateColDef(y, yIndex))
				})
				// columnDefs[0] && (columnDefs[0].headerClass = 'text-center')
				if (typeof detailCellRendererParams === 'function') {
					var newDetailCellRendererParams = (params) => {
						const res = detailCellRendererParams(params)
						res && res.detailGridOptions && res.detailGridOptions.columnDefs.forEach((x, i) => {
							manipulateColDef(x, i)
						})
						return res
					}
				} else {

					detailCellRendererParams && detailCellRendererParams.detailGridOptions && detailCellRendererParams.detailGridOptions.columnDefs.forEach((x, i) => {
						manipulateColDef(x, i)
					})
				}
				columnDefs[0] && !columnDefs[0].headerClass && (columnDefs[0].headerClass = 'text-center')
				// console.log('data',data)
				// console.log('columnDefs',columnDefs)
				Array.isArray(data) && (this.rowData = data.map((x, i) => {
					columnDefs.forEach(y => {
						this.manipulateData(x, y, i)
						if (y.children) y.children.forEach((z, zIndex) => this.manipulateData(x, z, i))
					})
					return {
						id: Math.random().toString('32').slice(2),
						...x,
						rowNumber: i + 1
					}
				}))
				// console.log('rowData',this.rowData)
				// console.log('columnDefs',columnDefs)
				this.originalColDefs = _.cloneDeep(columnDefs)
				const getActiveState = this.getActiveState('agGrid_' + id)
				this.currentColumnDefs = getActiveState?.value || []
				if (this.currentColumnDefs?.length) {
					this.activeStateIsExist = true
					columnDefs.map(x => {
						let foundCurrentState = this.currentColumnDefs.find(y => y.field && y.field === x.field && y.headerName === x.headerName)
						if (!foundCurrentState) this.currentColumnDefs.forEach((c) => {
							if (c.children && x.children) {
								c.children.forEach(y => {
									let foundSubColumnDefs = x.children.find(z => y.field === z.field && y.headerName === z.headerName)
									if (foundSubColumnDefs) {
										y.width && (foundSubColumnDefs.width = y.width)
										y.hide && (foundSubColumnDefs.hide = y.hide)
										y.suppressSizeToFit && (foundSubColumnDefs.suppressSizeToFit = y.suppressSizeToFit)
									}
								})
							}
						})
						if (foundCurrentState) {
							foundCurrentState.width && (x.width = foundCurrentState.width)
							foundCurrentState.hide && (x.hide = foundCurrentState.hide)
							foundCurrentState.suppressSizeToFit && (x.suppressSizeToFit = foundCurrentState.suppressSizeToFit)
							return x
						} else return x
					})
					columnDefs.sort((a, b) => {
						const aIndex = this.currentColumnDefs.findIndex(x => (a.field === x.field && a.headerName === x.headerName))
						const bIndex = this.currentColumnDefs.findIndex(x => (b.field === x.field && b.headerName === x.headerName))
						if (aIndex === bIndex || aIndex === -1 || bIndex === -1) return 0
						if (aIndex > bIndex) return 1
						if (aIndex < bIndex) return -1
					})
				} else {
					this.activeStateIsExist = false
					this.currentColumnDefs = columnDefs
				}
				// console.log('columnDefs',columnDefs)
				this.columnDefs = _.cloneDeep(columnDefs)
				this.columnLookup = buildColumnLookup(this.columnDefs)
				this.setSettingButtonOptions()

				this.columnDefsForAg = _.cloneDeep(columnDefs.map(x => {
					if (x.children) x.children.map(y => {
						delete y.contentType
						delete y.searchable
						delete y.extractDataFuncForAgg
						return y
					})
					delete x.contentType
					delete x.searchable
					delete x.filterModel
					delete x.extractDataFuncForAgg
					return x
				}))
				this.defaultColDef = _.merge(this.defaultColDef, defaultColDef)

				this.sideBar = sideBar !== 'none' ? _.merge(this.sideBar, sideBar) : false
				this.rowSelection = rowSelection ? _.merge(this.rowSelection, rowSelection) : this.rowSelection
				this.cellSelectionAggReport = cellSelectionAggReport != null ? cellSelectionAggReport : this.cellSelectionAggReport
				this.pagination = pagination === 'undefined' ? false : pagination
				this.rowGroupPanelShow = rowGroupPanelShow === 'undefined' ? false : rowGroupPanelShow
				this.autoGroupColumnDef = manipulateColDef(_.merge(this.autoGroupColumnDef, autoGroupColumnDef))
				this.groupTotalRow = groupTotalRow || hasPriceColumn
				this.groupIncludeTotalFooter = (groupIncludeTotalFooter === 'undefined' ? false : groupIncludeTotalFooter) || hasPriceColumn
				this.masterDetail = masterDetail ? masterDetail : this.masterDetail
				if (typeof detailCellRendererParams === 'function') {
					this.detailCellRendererParams = newDetailCellRendererParams
				} else {
					this.detailCellRendererParams = _.merge(this.detailCellRendererParams, detailCellRendererParams)
					this.nestedFieldName = this.detailCellRendererParams.detailGridOptions?.nestedFieldName
				}
				this.doubleClickedToSelect = typeof doubleClickedToSelect === "undefined" ? false : doubleClickedToSelect
				this.enterToSelect = typeof enterToSelect === "undefined" ? false : enterToSelect
				this.fitToWidth = typeof fitToWidth === "undefined" ? false : fitToWidth
				this.getDataPath = getDataPath === 'undefined' ? this.getDataPath : getDataPath
				this.treeData = treeData === 'undefined' ? false : treeData
				this.treeLevelRowColors = treeLevelRowColors === undefined ? this.treeLevelRowColors : treeLevelRowColors
				this.rowHeight = rowHeight === 'undefined' ? this.rowHeight : rowHeight
				this.excelExportParams = excelExportParams || {}
				this.csvExportParams = csvExportParams || {}
				this.groupDefaultExpanded = groupDefaultExpanded === 'undefined' ? 0 : groupDefaultExpanded
				this.isGroupOpenByDefault = isGroupOpenByDefault === 'undefined' ? this.isGroupOpenByDefault : isGroupOpenByDefault
				this.rowModelType = rowModelType
				serverSideDatasource && (this.serverSideDataSource = serverSideDatasource)
				this.serverInfo = _.merge(this.serverInfo, serverInfo)
				this.paginationPageSize = paginationPageSize ? paginationPageSize : this.paginationPageSize
				this.rawId = id
				this.getRowClass = getRowClass ? getRowClass : undefined
				this.rowClassRules = _.merge(this.rowClassRules, rowClassRules)
				this.suppressRowHoverHighlight = suppressRowHoverHighlight || false
				this.columnHoverHighlight = columnHoverHighlight || false
				this.onFirstDataRendered = onFirstDataRendered || undefined
				this.onRowClicked = onRowClicked
				this.groupDisplayType = groupDisplayType
				this.isRowMaster = isRowMaster || this.isRowMaster
				this.getRowId = getRowId ? getRowId : (params) => params.data[this.identifier]
				this.watchData = watchData === undefined ? this.watchData : watchData
				this.watchForSelectedChanges = watchForSelectedChanges === undefined ? this.watchForSelectedChanges : watchForSelectedChanges
				this.isServerSideGroup = isServerSideGroup
				this.getServerSideGroupKey = getServerSideGroupKey
				this.cacheBlockSize = cacheBlockSize ?? this.cacheBlockSize
				this.paginationAutoPageSize = paginationAutoPageSize ?? true
				this.paginationPageSizeSelector = paginationPageSizeSelector ?? false
				this.keepSelectionOrder = keepSelectionOrder ?? false
			},
		},
	}
</script>

<style lang="less">
	@import "~/styles/site.config.less";


	.tree-level-2 {
		background-color: rgb(190 193 252 / 80%)
	}

	.tree-level-3 {
		background-color: rgb(241 252 175 / 80%)
	}

	.tree-level-4 {
		background-color: rgb(252 184 160 / 80%)
	}

	//each(range(5), {
	//	//@temp :(@value - (2 * (floor(@value / 2))));
	//	//.tree-level-@{index} {
	//	//	background-color:if(@temp > 0, rgba(200, 200, 200, 0.20), rgba(100, 100, 100, 0.20)) ;
	//	//}
	//	//.tree-level-@{index}:after
	//	//{
	//	//	content: "@{temp}";
	//	//}
	//  .tree-level-@{index} {
	//		background-color: if(@index > 1, rgba(220-@value*15, 250-@value*15, 252, 0.8), white)
	//	}
	//});

	.ag-row-pinned {
		background-color: #ffefef;
	}

	.ag-header-select-all {
		margin-right: 5px;
	}

	.ag-header-cell-comp-wrapper {
		justify-content: center;
	}

	.ag-header-cell-comp-wrapper>.grid-settings {
		position: fixed;
		display: inline-flex;
		z-index: 20;
	}

	.ag-theme-alpine,
	.ag-theme-quartz {
		--ag-font-family: iranyekan !important;
		--ag-grid-size: 4px;
		--ag-header-column-separator-display: block;
		--ag-header-column-separator-height: 50%;
		--ag-header-column-separator-width: 1px;
		--ag-header-column-separator-color: #cecece;
		--ag-cell-horizontal-border: solid #eee;
		--ag-font-size: 11px;

		.ag-sort-indicator-container:has(.ag-sort-order:not(.ag-hidden)) {
			background: @primary;
			color: white !important;
			border-radius: 12px;
			font-size: 12px;
			margin-right: 4px;

			.ag-sort-indicator-icon:has(.ag-icon) {
				padding-right: 1px;
			}

			.ag-icon {
				color: white !important;
			}
		}
	}


	.ag-pivot-off .ag-header-group-cell-label {
		font-size: 16px;
		justify-content: center;
	}

	.ag-pivot-on .ag-header-group-cell {
		font-size: 10px;
		color: green;
	}

	.ag-header-cell.text-center>.ag-header-cell-comp-wrapper>.ag-cell-label-container>.ag-header-cell-label {
		align-items: center;
		justify-content: center;
	}

	.ag-header-group-cell-label,
	.ag-header-cell-label {
		align-items: center;
		justify-content: center;
	}

	.ag-root-wrapper {
		border-radius: 8px;
	}

	.nk-pagination-page-jump {
		display: inline-flex;
		align-items: center;
		margin: 0 8px;
		gap: 4px;

		.nk-pagination-page-jump-input {
			width: 52px;
			height: 24px;
			padding: 2px 6px;
			text-align: center;
		}

		.nk-pagination-page-jump-label,
		.nk-pagination-page-jump-total {
			white-space: nowrap;
		}
	}

	.row-deleted {
		opacity: 0.5;

		.row-state-circle {
			background-color: rgb(236, 66, 66);
		}
	}

	.row-new {
		background-color: rgb(243, 255, 243);

		.row-state-circle {
			background-color: rgb(45, 202, 45);
		}
	}

	.row-changed {
		background-color: rgb(255, 251, 243);

		.row-state-circle {
			background-color: rgb(255, 193, 7);
		}
	}

	.row-invalid {
		background-color: rgb(255, 204, 204);
	}

	.cell-invalid {
		background-color: rgb(255, 147, 147)
	}

	// .ag-cell {
	// 	border-left: 1px solid #eee;
	// }

	.ag-header-cell::after,
	.ag-header-group-cell::after {
		z-index: 0;
	}

	.ag-header-cell-resize::after {
		background-color: transparent;
	}

	.validation-warning {
		background-color: @row-bg-error !important;
	}

	.validation-warning::before {
		background-color: transparent !important;
		background-image: none !important;
	}

	.cascade-level-1 {
		background: #8a8a8a !important;
	}

	.cascade-level-2 {
		background: #b2b2b2 !important;
	}

	.cascade-level-3 {
		background: #dedede !important;
	}

	.cascade-level-4 {
		background: #ffffff !important;
	}

	.ag-rtl .ag-cell-wrapper.ag-row-group,
	.ag-rtl .ag-cell-wrapper.ag-row-group-leaf-indent,
	.ag-rtl .ag-cell-wrapper.ag-pivot-leaf-group {
		padding-right: calc(var(--ag-indentation-level) * var(--ag-row-group-indent-size));
	}
</style>
